import OperationsUtilizationReport from "../../components/Operations/UtilizationReport/OperationsUtilizationReport";

const OperationsUtilizationReportPage = () => {
  return <OperationsUtilizationReport />;
};

export default OperationsUtilizationReportPage;
